import React from 'react'

export const MoreActionThreeDotsSvg = ({ size = '24' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="#FFF" fillRule="evenodd">
      <circle cx="12" cy="20" r="2.5" />
      <path d="M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
      <circle cx="12" cy="4" r="2.5" />
    </g>
  </svg>
)
